import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Profile from "../pages/profile/page";
import Contact from "../pages/contact/page";
import WeChat from "../pages/wechat/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/wechat",
    element: <WeChat />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
